import axios, { AxiosInstance } from 'axios';
import { fetchEventSource, EventSourceMessage } from '@microsoft/fetch-event-source';

const BACKEND_BASE_URL = process.env.REACT_APP_BACKEND_HOST;

class AxiosClient {
    private client: AxiosInstance;

    constructor() {
        this.client = axios.create({
            baseURL: BACKEND_BASE_URL,
        });
    }

    isAuthenticated() {
        return 'Authorization' in this.client.defaults.headers.common
    }

    getHeaders() {
        return this.client.defaults.headers.common;
    }

    removeHeader(name: string) {
        delete this.client.defaults.headers.common[name];
    }

    setHeader(name: string, value: string) {
        this.client.defaults.headers.common[name] = value;
    }

    get(url: string) {
        return this.client.get(url);
    }

    post(url: string, data: any) {
        return this.client.post(url, data);
    }
}

const cl = new AxiosClient();
const setJWTHeader = (isLogout=false) => {
    cl.setHeader("Authorization", isLogout? "" : localStorage.getItem("access_token") !);
}

const verifyAuth = () => {
    return cl.post("/auth/verify-token", null).catch(() => {
        localStorage.removeItem("access_token");
        setJWTHeader(true);
    });
};


const refreshToken = async () => {
    try {
      const response = await cl.post("/auth/refresh-token", {
        refresh_token: localStorage.getItem("refresh_token"),
      });
      const data: { [key: string]: string } = response.data.data;
      localStorage.setItem("access_token", data.access_token);
      localStorage.setItem("refresh_token", data.refresh_token);
      localStorage.setItem("expires_at", data.expires_at);
      setJWTHeader();
      return response;
    } catch (error: any) {
      return error.response;
    }
  };

  if (localStorage.getItem('access_token')) {
    setJWTHeader()

    const currentTime = Math.floor(Date.now() / 1000);
    if ('expires_at' in localStorage) {
    const expiresAt = parseInt(localStorage.getItem('expires_at')!);
    if (expiresAt < currentTime) {
        refreshToken()
    }
    }

    verifyAuth()
}

export const setUserInfo = (userData:any) => {
    const useInfo ={
        photoURL:userData.user.photoURL, name:userData.user.displayName, email:userData.user.email
    }
    localStorage.setItem('user_info', JSON.stringify(useInfo))
}

export const axiosClient = cl
